import { API_URL } from './apiConfig';

function urlBase64ToUint8Array(base64String) {
  try {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
  } catch { return null; }
}

export async function registerPushNotifications() {
  // Silently bail out if not supported or already denied
  try {
    if (!('serviceWorker' in navigator)) return;
    if (!('PushManager' in window)) return;
    if (Notification.permission === 'denied') return;

    // Get stored user — no user = no push needed
    let u_id;
    try {
      const stored = localStorage.getItem('user');
      if (!stored) return;
      const u = JSON.parse(stored);
      u_id = u?.u_id;
      if (!u_id) return;
    } catch { return; }

    // Register service worker
    let reg;
    try {
      reg = await navigator.serviceWorker.register('/sw.js');
    } catch { return; }

    // Request permission only if not already granted
    if (Notification.permission !== 'granted') {
      const perm = await Notification.requestPermission().catch(() => 'denied');
      if (perm !== 'granted') return;
    }

    // Fetch VAPID key — if backend isn't ready, bail silently
    let publicKey;
    try {
      const res = await fetch(`${API_URL}/notifications/push/vapid-key`, { signal: AbortSignal.timeout(5000) });
      if (!res.ok) return;
      const json = await res.json();
      publicKey = json?.publicKey;
      if (!publicKey) return;
    } catch { return; }

    // Convert key
    const appKey = urlBase64ToUint8Array(publicKey);
    if (!appKey) return;

    // Subscribe
    let subscription;
    try {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: appKey,
      });
    } catch { return; }

    // Save to backend — fire and forget
    fetch(`${API_URL}/notifications/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ u_id, subscription }),
    }).catch(() => {});

  } catch {
    // Swallow ALL errors — push is non-critical
  }
}
